/**
 * Email input component with validation
 */

import React from 'react';
import { Mail } from 'lucide-react';

/**
 * Email input component
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data object
 * @param {Function} props.handleChange - Change handler function
 * @param {Object} props.errors - Form errors object
 * @param {Array} props.universities - List of universities
 * @returns {JSX.Element} Email input component
 */
const EmailInput = ({ formData, handleChange, errors, universities }) => {
  // Get selected university domain
  const getSelectedUniversityDomain = () => {
    if (!formData.university) return null;
    const selectedUniversity = universities.find(uni => uni.name === formData.university);
    return selectedUniversity ? selectedUniversity.domain : null;
  };

  const universityDomain = getSelectedUniversityDomain();

  return (
    <div className="space-y-2">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Mail className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="email"
          name="email"
          placeholder={universityDomain ? `Email address${universityDomain}` : "University email address"}
          value={formData.email}
          onChange={handleChange}
          className={`pl-10 pr-4 py-3 w-full bg-gray-50 border ${
            errors.email ? 'border-red-500' : 'border-gray-200'
          } rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent`}
        />
      </div>
      {errors.email && (
        <p className="text-red-500 text-sm">{errors.email}</p>
      )}
      {formData.university && universityDomain && !errors.email && (
        <p className="text-gray-500 text-xs">
          Use your {formData.university} email address {universityDomain}
        </p>
      )}
    </div>
  );
};

export default EmailInput;